import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig as _updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import AddInput from "../AddInput/index";
import networkInfo from "../networkInfo/index";
import { cloneDeep, isEqual } from 'lodash';
import { getProgressStatus, progressControl } from "../../../../../api/particulars";
export default {
  name: "PPTP",
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    var _this = this;

    var checkIp = function checkIp(rule, value, callback) {
      if (value) {
        console.log(value);
        var ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/;
        var domain = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
        var url = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;
        var val = value.indexOf(':');
        console.log('val');
        console.log(val);

        if (val === -1) {
          callback(new Error(_this.$t('lang.L2TP.assignedAddressError')));
        } else {
          var ipaddr = value.split(':');

          if ((ip.test(ipaddr[0]) || domain.test(ipaddr[0]) || url.test(ipaddr[0])) && (ip.test(ipaddr[1]) || domain.test(ipaddr[1]) || url.test(ipaddr[1]))) {
            callback();
          } else {
            callback(new Error(_this.$t('lang.L2TP.assignedAddressError')));
          }
        }
      } else {
        callback();
      }
    };

    return {
      loading: true,
      ProtoList: [{
        value: 'pptp',
        label: 'PPTP'
      }],
      MppeList: [{
        value: '0',
        label: 'Disable'
      }, {
        value: '1',
        label: 'Auto'
      }, {
        value: '2',
        label: 'Statefull'
      }, {
        value: '3',
        label: 'Stateless'
      }],
      //LCP响应故障阈值
      LcpOne: '',
      //LCP响应间隔
      LcpTwo: '',
      copyLcpOne: '',
      copyLcpTwo: '',
      value: false,
      data: {},
      WatchData: {},
      // 网络接口基本信息
      networkInfo: {},
      timer: null,
      isSwitch: false,
      vpntimer: null,
      // 设置密码是否可见
      pwdInputType: 'password',
      rules: {
        ipaddr: [{
          validator: checkIp,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        this.getConfig();
        this.fetchNetworkInfo();
      }
    }
  },
  mounted: function mounted() {
    this.GetVpnStatus();
  },
  activated: function activated() {
    var _this2 = this;

    this.fetchNetworkInfo();
    this.timer = setInterval(function () {
      _this2.fetchNetworkInfo();
    }, 10000);
  },
  deactivated: function deactivated() {
    clearInterval(this.timer);
    clearInterval(this.vpntimer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.vpntimer);
  },
  methods: {
    // 获取lan接口基本信息
    fetchNetworkInfo: function fetchNetworkInfo() {
      var _this3 = this;

      getNetworkInfo(this.deviceDid, this.deviceSn, ['pptp1']).then(function (res) {
        _this3.networkInfo = res.data.data.mess.pptp1;
      });
    },
    //获取配置参数
    getConfig: function getConfig() {
      var _this4 = this;

      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "pptp1",
        config: "network",
        options: [{
          option: "proto"
        }, {
          option: "server"
        }, {
          option: "username"
        }, {
          option: "password"
        }, {
          option: "auto"
        }, {
          option: "defaultroute"
        }, {
          option: "mppe"
        }, {
          option: "keepalive"
        }, {
          option: "ipaddr"
        }, {
          option: "pppd_options"
        }, {
          option: "disabled"
        }, //是否禁用
        {
          option: "metric"
        }, //使用网关跃点
        {
          option: "peerdns"
        }, //使用对端通告的dns服务器
        {
          option: "mtu"
        }, //mtu
        {
          option: "demand"
        }, //超时
        {
          option: "dns"
        } //dns
        ]
      }]).then(function (res) {
        _this4.data = res.data.data.mess[0].s_objects[0].options; //添加默认配置参数,将复选框值转换成布尔值

        _this4.data.auto = _this4.data.auto == '1' ? true : false;
        _this4.data.defaultroute = _this4.data.defaultroute == '0' ? false : true;
        _this4.data.disabled = _this4.data.disabled == '0' ? false : true;
        _this4.data.peerdns = _this4.data.peerdns == '0' ? false : true; //添加配置参数为空的默认值

        _this4.data.mppe = _this4.data.mppe == '' ? '3' : _this4.data.mppe;
        _this4.data.keepalive = _this4.data.keepalive == '' ? _this4.data.keepalive = '5 3' : _this4.data.keepalive; //获取 LCP响应故障阈值 和LCP响应间隔

        if (_this4.LcpOne == '') {
          _this4.LcpOne = _this4.data.keepalive.split(' ')[0];
          _this4.copyLcpOne = cloneDeep(_this4.LcpOne);
        }

        if (_this4.LcpTwo == '') {
          _this4.LcpTwo = _this4.data.keepalive.split(' ')[1];
          _this4.copyLcpTwo = cloneDeep(_this4.LcpTwo);
        }

        _this4.WatchData = cloneDeep(_this4.data);
        _this4.loading = false;
        _this4.isSwitch = false;
        clearInterval(_this4.vpntimer);
        clearInterval(_this4.timer);
        _this4.timer = setInterval(function () {
          _this4.fetchNetworkInfo();
        }, 10000);
      }).catch(function (err) {
        if (!_this4.isSwitch) {
          // 不是点击启用/停用/保存应用做的操作
          _this4.$message({
            message: _this4.$t('lang.request.timeout'),
            type: "warning"
          });
        }
      });
    },
    //接收AddInput的改变传过来的值
    GetAddInput: function GetAddInput(props) {
      this.data.pppd_options = props;
    },
    //获取vpn运行状态
    GetVpnStatus: function GetVpnStatus() {
      var _this5 = this;

      getProgressStatus(this.deviceDid, this.deviceSn, {
        network: ['pptp1']
      }).then(function (res) {
        _this5.value = res.data.data.mess[0].status == 1 ? true : false;
      });
    },
    //Vpn开关切换
    SwitchChange: function SwitchChange(e) {
      var _this6 = this;

      // this.data={}
      this.isSwitch = true;
      clearInterval(this.vpntimer); // 清除之前的请求，不然当用户频繁切换开关的时候会导致切换几次就会进行请求刷新好几次
      // 清除之前的只执行最新的一次请求

      this.$store.dispatch('clearToken');
      progressControl([{
        process: 'pptp1',
        type: 1,
        action: e ? 'start' : 'stop'
      }], this.deviceDid.toString(), this.deviceSn).then(function (res) {
        clearInterval(_this6.timer);
        _this6.vpntimer = setInterval(function () {
          _this6.GetVpnStatus();

          _this6.getConfig();

          _this6.fetchNetworkInfo();
        }, 10000);
      });
    },
    // 密码是否可见
    setPWDView: function setPWDView() {
      if (this.pwdInputType === 'password') {
        this.pwdInputType = '';
      } else {
        this.pwdInputType = 'password';
      }
    },
    //保存配置
    updateConfig: function updateConfig() {
      var _this7 = this;

      // 校验表单
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          if (!isEqual(_this7.data, _this7.WatchData) || !isEqual(_this7.copyLcpTwo, _this7.LcpTwo) || !isEqual(_this7.copyLcpOne, _this7.LcpOne)) {
            //保存配置时转换
            _this7.data.auto = _this7.data.auto ? '1' : '0';
            _this7.data.defaultroute = !_this7.data.defaultroute ? '0' : '';
            _this7.data.keepalive = _this7.LcpOne + ' ' + _this7.LcpTwo;
            _this7.data.disabled = _this7.data.disabled ? '1' : '0';
            _this7.data.peerdns = _this7.data.peerdns ? '1' : '0';
            var data = _this7.data; // 清除之前的只执行最新的一次请求

            _this7.$store.dispatch('clearToken'); // 清空之前的定时器，防止切换开关的同时保存修改，那么会有多个计时器，将会一直在刷新


            clearInterval(_this7.timer);
            clearInterval(_this7.vpntimer);

            _updateConfig(_this7.deviceSn, _this7.deviceDid, [{
              section: "pptp1",
              config: "network",
              action: 0,
              index: [0],
              options: _objectSpread({}, data)
            }]).then(function (res) {
              if (res.data.data.mess === 0) {
                _this7.loading = true;
                progressControl([{
                  process: 'pptp1',
                  type: 1,
                  action: 'restart'
                }], _this7.deviceDid.toString(), _this7.deviceSn).then(function (res) {
                  _this7.$message({
                    showClose: true,
                    message: _this7.$t('lang.ConfigSetting.Successfulconfiguration'),
                    type: "success"
                  }); // this.data={}


                  clearInterval(_this7.timer);
                  _this7.vpntimer = setInterval(function () {
                    _this7.GetVpnStatus();

                    _this7.getConfig();

                    _this7.fetchNetworkInfo();
                  }, 10000);
                });
              } else {
                _this7.$message({
                  showClose: true,
                  message: _this7.$t('lang.ConfigSetting.Configurationerror'),
                  type: "warning"
                });

                return;
              }
            }).catch(function (err) {
              console.log('请求超时');
              console.log(err);
            });
          } else {
            _this7.$message({
              showClose: true,
              message: _this7.$t('lang.ConfigSetting.Nochangesmade'),
              type: 'warning'
            });

            return;
          }
        } else {
          return false;
        }
      });
    }
  },
  components: {
    AddInput: AddInput,
    networkInfo: networkInfo
  }
};